export default __webpack_public_path__ + "static/media/paycor.160b6d12.svg";